import React, { useEffect, useState } from 'react';

const MessageToast = ({ message, type = 'info', duration = 5000, onClose }) => {
 const [isVisible, setIsVisible] = useState(true);
 const [isExiting, setIsExiting] = useState(false);

 useEffect(() => {
 if (duration > 0) {
 const timer = setTimeout(() => {
 handleClose();
 }, duration);

 return () => clearTimeout(timer);
 }
 return undefined;
 // eslint-disable-next-line react-hooks/exhaustive-deps -- handleClose is stable enough, avoid re-running on every render
 }, [duration]);

 const handleClose = () => {
 setIsExiting(true);
 setTimeout(() => {
 setIsVisible(false);
 onClose?.();
 }, 300);
 };

 const getToastStyles = () => {
 const baseClasses = 'fixed top-4 right-4 max-w-sm w-full p-4 shadow-md transform transition-all duration-300';
 
 const toastVariants = {
 success: 'bg-success text-toast border border-success',
 error: 'bg-error text-toast border border-error',
 warning: 'bg-warning text-toast border border-warning',
 info: 'bg-accent text-toast border border-accent'
 };

 const animationClasses = isExiting 
 ? 'translate-x-full opacity-0 scale-95' 
 : 'translate-x-0 opacity-100 scale-100';

 return `${baseClasses} ${toastVariants[type]} ${animationClasses}`;
 };

 const getIcon = () => {
 const iconClasses = 'w-5 h-5';
 
 switch (type) {
 case 'success':
 return (
 <svg className={iconClasses} fill="currentColor" viewBox="0 0 20 20">
 <path fillRule="evenodd" d="M10 18a8 8 0 100-16 8 8 0 000 16zm3.707-9.293a1 1 0 00-1.414-1.414L9 10.586 7.707 9.293a1 1 0 00-1.414 1.414l2 2a1 1 0 001.414 0l4-4z" clipRule="evenodd" />
 </svg>
 );
 case 'error':
 return (
 <svg className={iconClasses} fill="currentColor" viewBox="0 0 20 20">
 <path fillRule="evenodd" d="M10 18a8 8 0 100-16 8 8 0 000 16zM8.707 7.293a1 1 0 00-1.414 1.414L8.586 10l-1.293 1.293a1 1 0 101.414 1.414L10 11.414l1.293 1.293a1 1 0 001.414-1.414L11.414 10l1.293-1.293a1 1 0 00-1.414-1.414L10 8.586 8.707 7.293z" clipRule="evenodd" />
 </svg>
 );
 case 'warning':
 return (
 <svg className={iconClasses} fill="currentColor" viewBox="0 0 20 20">
 <path fillRule="evenodd" d="M8.257 3.099c.765-1.36 2.722-1.36 3.486 0l5.58 9.92c.75 1.334-.213 2.98-1.742 2.98H4.42c-1.53 0-2.493-1.646-1.743-2.98l5.58-9.92zM11 13a1 1 0 11-2 0 1 1 0 012 0zm-1-8a1 1 0 00-1 1v3a1 1 0 002 0V6a1 1 0 00-1-1z" clipRule="evenodd" />
 </svg>
 );
 default:
 return (
 <svg className={iconClasses} fill="currentColor" viewBox="0 0 20 20">
 <path fillRule="evenodd" d="M18 10a8 8 0 11-16 0 8 8 0 0116 0zm-7-4a1 1 0 11-2 0 1 1 0 012 0zM9 9a1 1 0 000 2v3a1 1 0 001 1h1a1 1 0 100-2v-3a1 1 0 00-1-1H9z" clipRule="evenodd" />
 </svg>
 );
 }
 };

 if (!isVisible) return null;

 return (
 <div className={getToastStyles()} style={{ zIndex: 'var(--z-toast)' }}>
 <div className="flex items-start">
 <div className="flex-shrink-0">
 {getIcon()}
 </div>
 <div className="ml-3 flex-1">
 <p className="text-sm font-medium">
 {message}
 </p>
 </div>
 <div className="ml-4 flex-shrink-0 flex">
 <button
 onClick={handleClose}
 className="inline-flex text-current hover:opacity-75 focus:outline-none focus:ring-2 focus:ring-offset-2 focus:ring-current transition-opacity duration-200"
 >
 <svg className="w-4 h-4" fill="currentColor" viewBox="0 0 20 20">
 <path fillRule="evenodd" d="M4.293 4.293a1 1 0 011.414 0L10 8.586l4.293-4.293a1 1 0 111.414 1.414L11.414 10l4.293 4.293a1 1 0 01-1.414 1.414L10 11.414l-4.293 4.293a1 1 0 01-1.414-1.414L8.586 10 4.293 5.707a1 1 0 010-1.414z" clipRule="evenodd" />
 </svg>
 </button>
 </div>
 </div>
 </div>
 );
};

export { MessageToast };
export default MessageToast; 